import { NavLink } from 'react-router-dom';

import type { NavRailItem } from './config';

interface NavBottomTabProps {
  item: NavRailItem;
  /** Colour when this is the page you are on. */
  accent: string;
  /** Colour otherwise. */
  idle: string;
}

/** One destination in the mobile bottom bar. */
export default function NavBottomTab({ item, accent, idle }: NavBottomTabProps) {
  const Icon = item.icon;
  return (
    <NavLink
      to={item.to}
      className="flex flex-1 flex-col items-center justify-center gap-0.5 no-underline"
      style={({ isActive }) => ({ color: isActive ? accent : idle })}
    >
      <Icon size={20} aria-hidden />
      <span className="text-[9.5px] font-bold tracking-wide">{item.label}</span>
    </NavLink>
  );
}
